import TacticsPage from "../../../products/strategy_tool/TacticsPage";
import UserHoldingsPage from "../../../products/user_holdings/UserHoldingsPage";
import CompanionRoomPage from "../../../products/companion_room/CompanionRoomPage";
import IntelligenceFeedPage from "../../../products/intel/IntelligenceFeedPage";
import ViewpointFeedPage from "../../../products/viewpoint/ViewpointFeedPage";
import FollowPoolPage from "../../../products/follow_pool/FollowPoolPage";
import ConceptPage from "../../../products/concept/ConceptPage";
import InstHotspotPage from "../../../products/inst_hotspot/InstHotspotPage";
import MyNotesPage from "../../../products/my_notes/MyNotesPage";
import QaFeedPage from "../../../products/qa/QaFeedPage";
import CourseResourceHub from "../../../products/course_resource/CourseResourceHub";
import { normalizeIntelCommentKind } from "../SpaceType";
import type { MemberBadge } from "../../../components/member-badge/MemberBadgeType";
import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { SpaceModuleSubscribeGate } from "./SpaceModuleSubscribeGate";
import { SpaceModuleSubscribedSoon } from "./SpaceModuleSubscribedSoon";

export function SpaceProductSection(props: {
  spaceId: string;
  sectionKey: string;
  module: MembershipProduct | null;
  membershipProducts: MembershipProduct[];
  spaceProfile: SpaceProfile | null;
  isLoggedIn: boolean;
  onLoginRequest: () => void;
  myMemberBadges?: MemberBadge[] | null;
}): JSX.Element {
  const {
    spaceId,
    sectionKey,
    module,
    membershipProducts,
    spaceProfile,
    isLoggedIn,
    onLoginRequest,
    myMemberBadges,
  } = props;

  if (!module) {
    return <div className="space-section-placeholder" />;
  }

  if (!module.userSubscribed) {
    return (
      <SpaceModuleSubscribeGate
        spaceId={spaceId}
        row={module}
        membershipProducts={membershipProducts}
        isLoggedIn={isLoggedIn}
        onLoginRequest={onLoginRequest}
        spaceProfile={spaceProfile}
      />
    );
  }

  switch (module.productKind) {
    case "group_companion":
      return (
        <CompanionRoomPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
          productDisplayName={module.displayName}
          spaceDisplayName={spaceProfile?.name?.trim()}
          membershipDaysRemaining={module.daysRemaining}
          subscribeHomePath={`/space/${spaceId}/home`}
          myMemberBadges={myMemberBadges}
        />
      );
    case "intel":
      return (
        <IntelligenceFeedPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
          spaceDisplayName={spaceProfile?.name?.trim() || "本空间"}
          intelCommentKind={normalizeIntelCommentKind(module.intelCommentKind)}
        />
      );
    case "viewpoint":
      return (
        <ViewpointFeedPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
          spaceDisplayName={module.displayName?.trim() || ""}
        />
      );
    case "user_holdings":
      return <UserHoldingsPage spaceId={spaceId} />;
    case "user_notes":
      return <MyNotesPage spaceId={spaceId} />;
    case "follow_pool":
      return (
        <FollowPoolPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
        />
      );
    case "concept":
      return (
        <ConceptPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
        />
      );
    case "inst_hotspot":
      return (
        <InstHotspotPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
        />
      );
    case "strategy_tool":
      return (
        <TacticsPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
        />
      );
    case "qa":
      return (
        <QaFeedPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
          qaAllowPublic={module.qaAllowPublic === true}
        />
      );
    case "course_resource":
      return (
        <CourseResourceHub spaceId={spaceId} spaceProductId={module.spaceProductId} />
      );
    default:
      return <SpaceModuleSubscribedSoon spaceProfile={spaceProfile} />;
  }
}
